import React from 'react';
import styled from 'styled-components';
import { ITooltipOption } from '../../../../components/KubitTooltip/globalTooltips';
import InformationalTooltip from '../../../../components/InformationalTooltip';
import { FieldLabel } from '../../../../components/Form';

interface IProps {
  labelText: string;
  tooltipOption?: ITooltipOption;
}

const StyledFieldLabel = styled(FieldLabel)`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const DataModelerConfigLabelWithInfo = ({
  labelText,
  tooltipOption,
}: IProps) => {
  return (
    <StyledFieldLabel>
      {labelText}
      {tooltipOption && <InformationalTooltip tooltipOption={tooltipOption} />}
    </StyledFieldLabel>
  );
};

export default DataModelerConfigLabelWithInfo;
